import React from 'react';
import {Navigate,useLocation} from 'react-router-dom';
import {legacyHomeWorkspaceLocation} from '../../utils/homeWorkspaceRoute';
export default function HomeWorkspaceRedirect(){const location=useLocation();return <Navigate replace to={legacyHomeWorkspaceLocation(location)||{pathname:'/home',search:location.search,hash:location.hash}}/>;}
